export interface DarePack {
  id: 'default' | 'spicy' | 'mild';
  name: string;
  description: string;
  dares: string[];
}

const defaultPack: DarePack = {
  id: 'default',
  name: 'Default',
  description: 'Fun party dares for everyone',
  dares: [
    'Do 10 pushups right now',
    'Do your best celebrity impression for 30 seconds',
    'Let someone draw on your face with a marker',
    'Speak in an accent for the next 3 rounds',
    'Do a plank for 30 seconds',
    'Show the last photo you took on your phone',
    'Do your best dance move',
    'Tell an embarrassing childhood story',
    'Sing the chorus of the last song you listened to',
    'Let the group pick a new nickname for you for the rest of the game',
    'Do 15 jumping jacks',
    'Try to lick your elbow',
    'Talk in a whisper for the next 2 rounds',
    'Do your best animal impression',
    'Hold an ice cube in your hand until it melts',
    'Let someone tickle you for 10 seconds',
    'Say the alphabet backwards',
    'Do a cartwheel or somersault',
    'Speak in third person for the next 2 rounds',
    'Let the group style your hair however they want',
    'Do a handstand against the wall for 10 seconds',
    'Act out a movie scene and let others guess the movie',
    'Do 20 squats',
    'Tell your most embarrassing moment from this year',
    'Let someone go through your recent search history',
    'Imitate another player until someone guesses who',
    'Do a dramatic reading of the last text you sent',
    'Eat a spoonful of a condiment chosen by the group',
    'Wear your shirt inside out for the rest of the game',
    'Make up a rap about the person to your left',
    'Do the worm or attempt to',
    'Talk without closing your mouth for 1 minute',
    'Let the group take a photo of you in a silly pose',
    'Do your best impression of a baby',
    'Stand on one foot for the next round',
    'Tell a joke and if nobody laughs you lose the point',
    'Do a trust fall with someone',
    'Describe your crush or partner using only food comparisons',
    'Let someone send a text from your phone (group approved)',
    'Do an interpretive dance of your day so far',
    'Balance a cup on your head for 30 seconds',
    'Say something nice about every player in the room',
    'Do your best moonwalk',
    'Arm wrestle the player to your right',
    'Speak only in questions for the next 2 rounds',
    'Do your best yoga pose and hold it for 20 seconds',
    'Let the group pick an outfit for you from your closet',
    'Recreate a famous painting pose',
    'Tell a story using only sound effects',
    'Give a 30-second motivational speech about spoons',
  ],
};

const spicyPack: DarePack = {
  id: 'spicy',
  name: 'Spicy',
  description: 'More intense dares for the brave',
  dares: [
    'Post an embarrassing selfie to your social media',
    'Call a random contact and sing happy birthday to them',
    'Let someone post a story on your social media',
    'Text your crush something the group decides',
    'Show your most embarrassing saved photo',
    'Let someone look through your DMs for 30 seconds',
    'Call your mom and tell her you got a tattoo',
    'Do a belly flop on the couch',
    'Let someone write a status update on your social media',
    'Confess your most embarrassing habit',
    'Let the group read your last 5 outgoing texts aloud',
    'Record a video of you doing a silly dance and send it to someone',
    'Let someone pick a contact to call and you must talk for 1 minute',
    'Share your screen time report with the group',
    'Reveal your most embarrassing Google search',
    'Post a thirst trap photo right now',
    'Call a pizza place and try to order sushi',
    'Send a voice note singing to someone the group picks',
    'Show your browser history from today',
    'Let the group compose and send a tweet from your account',
    'FaceTime a friend and pretend you are crying',
    'Text your boss or teacher something funny the group decides',
    'Do karaoke to a song chosen by the group',
    'Reveal the last lie you told',
    'Call a restaurant and try to make a reservation for 50',
    'Let someone swap your phone wallpaper',
    'Record yourself doing 5 star jumps and post it',
    'Read your most recent email out loud',
    'Call a friend and convince them you won the lottery',
    'Reveal the most embarrassing thing on your phone',
    'Let the group go through your saved memes',
    'Text someone "I need to tell you something important" and wait',
    'Share your most controversial opinion',
    'Do an embarrassing TikTok dance',
    'Call a store and ask if they sell dragon eggs',
    'Show your most used emoji and explain why',
    'Let someone pick your profile picture for 24 hours',
    'Confess something you have never told anyone',
    'Send a dramatic goodbye text to someone and then say just kidding',
    'Reveal your guilty pleasure song and sing it',
    'Call a friend and speak only in movie quotes for 1 minute',
    'Share the worst pickup line you have ever used or received',
    'Do an embarrassing impression of someone in the room',
    'Let the group write your dating app bio',
    'Text a friend and ask them to rate you out of 10',
    'Share your most embarrassing autocorrect fail',
    'Post a childhood photo with an embarrassing caption',
    'Call someone and pretend you are a radio host giving them a prize',
    'Show the group your Notes app',
    'Reveal your most played song and explain yourself',
  ],
};

const mildPack: DarePack = {
  id: 'mild',
  name: 'Mild',
  description: 'Tame and family-friendly dares',
  dares: [
    'Do a silly dance for 15 seconds',
    'Sing the chorus of a popular song',
    'Give a genuine compliment to every player',
    'Tell a funny joke',
    'Do your best robot impression',
    'Make a funny face and hold it for 10 seconds',
    'Tell us about your favorite childhood memory',
    'Do 5 jumping jacks while counting in another language',
    'Pretend to be a news anchor reporting on this game',
    'Do your best impression of a famous person',
    'Tell the group your hidden talent',
    'Hum a song and let others guess what it is',
    'Share the best compliment you ever received',
    'Stand up and take a bow like you just won an Oscar',
    'Tell a tongue twister three times fast',
    'Do your best slow-motion replay of an action',
    'Share what you wanted to be when you grew up',
    'Make up a short poem about the person to your right',
    'Tell your favorite fun fact',
    'Pretend to be a flight attendant for 30 seconds',
    'Show off your best air guitar solo',
    'Tell the group about your favorite movie and why',
    'Do a dramatic reading of a nursery rhyme',
    'Name 10 animals in 10 seconds',
    'Pretend to be a cooking show host making a sandwich',
    'Share the best advice you ever received',
    'Do your best penguin walk across the room',
    'Tell the group about your dream vacation',
    'Make the funniest sound you can',
    'Share your favorite dad joke',
    'Do your best impression of a cat',
    'Tell us about the nicest thing someone did for you',
    'Clap a rhythm and have others try to copy it',
    'Share a fun tradition your family has',
    'Do your best superhero landing pose',
    'Name 5 songs from a genre chosen by the group',
    'Tell the story of how you met your best friend',
    'Do a dramatic slow clap',
    'Share your most unpopular food opinion',
    'Pretend to be a sports commentator for 30 seconds',
    'Say three things you are grateful for today',
    'Do your best impression of a teacher',
    'Recite the pledge of allegiance or national anthem',
    'Tell us about a random act of kindness you did',
    'Do the chicken dance',
    'Share your go-to karaoke song',
    'Pretend you are accepting a Nobel Prize',
    'Tell the group what your theme song would be',
    'Do your best villain laugh',
    'Share the most interesting place you have visited',
  ],
};

export const darePacks: Record<DarePack['id'], DarePack> = {
  default: defaultPack,
  spicy: spicyPack,
  mild: mildPack,
};

export const darePackList: DarePack[] = [defaultPack, spicyPack, mildPack];
